import React, { useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import KeyBenefitsSection from '../components/home/KeyBenefitsSection';
import TeleconsultationSection from '../components/home/TeleconsultationSection';
import CarnetSanteSection from '../components/home/CarnetSanteSection';
import AdvantagesSection from '../components/home/AdvantagesSection';
import ConseilsSection from '../components/home/ConseilsSection';
import IntegrationShowcase from '../components/home/IntegrationShowcase';
import PromoBanner from '../components/promo/PromoBanner';
import FounderProgramBanner from '../components/home/FounderProgramBanner';
import VetRecruitmentSection from '../components/home/VetRecruitmentSection';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const HomePage = () => {
  const navigate = useNavigate();
  const [isLocating, setIsLocating] = useState(false);

  const handleSearch = (searchData) => {
    console.log('Search:', searchData);
    navigate('/recherche', { state: searchData });
  };

  const handleGeolocate = () => {
    setIsLocating(true);
    
    if (!navigator.geolocation) {
      toast.error('La géolocalisation n\'est pas supportée par votre navigateur');
      setIsLocating(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLocation = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        toast.success('Position trouvée !');
        setIsLocating(false);
        // Navigate to search page with location
        navigate('/recherche', { state: { userLocation } });
      },
      (error) => {
        let errorMessage = 'Impossible de récupérer votre position';
        switch(error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Vous avez refusé la géolocalisation';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Position indisponible';
            break;
          case error.TIMEOUT:
            errorMessage = 'Délai d\'attente dépassé';
            break;
        }
        toast.error(errorMessage);
        setIsLocating(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900 transition-colors">
      {/* Founder Program Banner - Urgent */}
      <FounderProgramBanner />
      {/* Promo Banner - Scrolling */}
      <PromoBanner variant="scrolling" />
      <Header />
      <main className="flex-grow">
        <HeroSection onSearch={handleSearch} onGeolocate={handleGeolocate} isLocating={isLocating} />
        <KeyBenefitsSection />
        {/* Vet Recruitment Section - B2B */}
        <VetRecruitmentSection />
        <TeleconsultationSection />
        <CarnetSanteSection />
        <IntegrationShowcase />
        <AdvantagesSection />
        <ConseilsSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
